import { CURRENT_LOCATION_INFO,CATEGORIES_LIST,CART_DATA,
  STORE_TYPE,
  SERVICE_LIST,
  STORE_LOCATION,
  CHECKOUT_NAVIGATION,
  STORE_FLAT_STREET,
  PICKUP_LOCATION,
  DESTINATION_LOCATION,
  VEHICLE_LIST,
  PICKUPDATE_TIME,
  WAY_TYPE,
  ACCEPT_COOKIES,
  RETURNDATE_TIME,
  SHOWMODIFY,
  CABBOOK_NAVIGATION,
  SET_STORE_MODAL_POPUP_SHOW
} from "./actionTypes";

export const currentLocationInfo = (currentLocation) => async (dispatch) => {
  dispatch({
    type: CURRENT_LOCATION_INFO,
    currentLocation: currentLocation,
  });
};

export const storeCategories = (categories) => async (dispatch) => {
  dispatch({
    type: CATEGORIES_LIST,
    categories: categories,
  });
};

export const storeServices = (serviceslist) => async (dispatch) => {
  dispatch({
    type: SERVICE_LIST,
    serviceslist: serviceslist,
  });
};

export const maintainCartdata = (cartdata, amount) => async (dispatch) => {
  dispatch({
    type: CART_DATA,
    cartdata: cartdata,
    amount: amount,
  });
};

export const maintainStoretype = (storetype) => async (dispatch) => {
  dispatch({
    type: STORE_TYPE,
    storetype: storetype,
  });
};

export const maintainStorelocation = (storelocation) => async (dispatch) => {
  dispatch({
    type: STORE_LOCATION,
    storelocation: storelocation,
  });
};

export const maintanCheckoutpage = (navigatecheckout) => async (dispatch) => {
  dispatch({
    type: CHECKOUT_NAVIGATION,
    navigatecheckout: navigatecheckout,
  });
};

export const maintainCabbook = (navigateCabbook) => async (dispatch) => {
  dispatch({
    type: CABBOOK_NAVIGATION,
    navigateCabbook: navigateCabbook
  })
}

export const maintainFlatstreet = (storeFlatstreet) => async (dispatch) => {
  dispatch({
    type: STORE_FLAT_STREET,
    storeFlatstreet: storeFlatstreet,
  });
};

export const maintainPickup = (pickup) => async (dispatch) => {
  dispatch({
    type: PICKUP_LOCATION,
    pickup: pickup,
  });
};

export const maintainDestination = (destination) => async (dispatch) => {
  dispatch({
    type: DESTINATION_LOCATION,
    destination: destination,
  });
};

export const maintainVehiclelist = (vehiclelist) => async (dispatch) => {
  dispatch({
    type: VEHICLE_LIST,
    vehiclelist: vehiclelist,
  });
};

export const maintainPickupdatetime = (pickupdate_time) => async (dispatch) => {
  dispatch({
    type: PICKUPDATE_TIME,
    pickupdate_time: pickupdate_time,
  });
};

export const maintainReturndatetime = (returndate_time) => async (dispatch) => {
  dispatch({
    type: RETURNDATE_TIME,
    returndate_time: returndate_time,
  });
};

export const maintainWaytype = (waytype) => async (dispatch) => {
  dispatch({
    type: WAY_TYPE,
    waytype: waytype,
  });
};
export const acceptCookies = (acceptcookies) => async (dispatch) => {
  dispatch({
    type: ACCEPT_COOKIES,
    acceptcookies: acceptcookies,
  });
};
export const maintainModify = (showmodify) => async (dispatch) => {
  dispatch({
    type: SHOWMODIFY,
    showmodify: showmodify,
  });
};
export const setStoreModalPopupShow = (payload) => {
  return{
    type: SET_STORE_MODAL_POPUP_SHOW,
    payload: payload,
  }
};